import { render, staticRenderFns } from "./AppCreate.vue?vue&type=template&id=6b66d9cd"
import script from "./AppCreate.vue?vue&type=script&lang=js"
export * from "./AppCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports